import "./InGamePlayer.css";
import CurrentTurnMarker from "./CurrentTurnMarker";
import { PlayerInfo, ProfileInfo } from "./common/Info";
import disconnectIcon from "./assets/disconnectIcon.svg";

interface InGamePlayerProp {
  currentTurn: boolean;
  playerInfo: PlayerInfo;
  profile: ProfileInfo;
}

function InGamePlayer({ currentTurn, playerInfo, profile }: InGamePlayerProp) {
  let connectionIcon = <span></span>;

  let connected = playerInfo.connected;

  // assume the current player is always connected
  if (playerInfo.id === profile.id) {
    connected = true;
  }

  if (!connected) {
    connectionIcon = <img className="disconnectIcon" src={disconnectIcon} />;
  }
  let score = <span></span>;
  if (playerInfo.score != undefined) {
    score = <span>{playerInfo.score}</span>;
  }
  let currentTurnMarker = <span></span>;
  if (currentTurn) {
    currentTurnMarker = <CurrentTurnMarker />;
  }
  return (
    <tr className="inGamePlayer">
      <td className="inGamePlayer">{currentTurnMarker}</td>
      <td className="inGamePlayer">{playerInfo.name}</td>
      <td className="inGamePlayer">{score}</td>
      <td className="inGamePlayer">{connectionIcon}</td>
    </tr>
  );
}

export default InGamePlayer;
